/**
 * CTA Height Matching
 * Sets CTA height to match the width of a single grid item
 */
document.addEventListener('DOMContentLoaded', function () {
	const ctaElements = document.querySelectorAll('.cta')

	function setCTAHeight() {
		// Only apply height matching above Tailwind 'sm' breakpoint (640px)
		if (window.innerWidth < 640) {
			// Reset height for mobile
			ctaElements.forEach((cta) => {
				cta.style.height = 'auto'
			})
			return
		}

		ctaElements.forEach((cta) => {
			const isSmall = cta.dataset.gridSmall === 'true'

			// Calculate what the width of a single grid item would be
			const containerWidth = cta.parentElement.parentElement.offsetWidth
			let itemWidth

			if (window.innerWidth >= 1024) {
				// lg breakpoint
				if (isSmall) {
					itemWidth = (containerWidth - 32) / 2 // 2 cols, gap-8 = 32px
				} else {
					itemWidth = (containerWidth - 96) / 4 // 4 cols, 3 gaps = 96px
				}
			} else {
				itemWidth = (containerWidth - 32) / 2 // Always 2 cols on smaller screens
			}

			cta.style.height = `${itemWidth}px`
		})
	}

	setCTAHeight()
	window.addEventListener('resize', setCTAHeight)
})
